import { Groups } from "@/features/members/groups";

export const Route = createFileRoute({
  component: Groups,
});
